import { languages, type Language } from '@osteopro/shared';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@osteopro/ui';
import { Check, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n/I18nProvider.js';

/** Endonymes : le nom d'une langue s'écrit toujours dans cette langue, jamais traduit. */
const ENDONYMS: Record<Language, string> = { fr: 'Français', de: 'Deutsch', en: 'English' };

export function LanguageToggle() {
  const { t, i18n } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" data-testid="button-language-toggle">
          <Globe className="h-5 w-5" />
          <span className="sr-only">{t('shell:language.toggle')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language}
            className="gap-2"
            onClick={() => void changeLanguage(language)}
            data-testid={`language-${language}`}
          >
            <span className="flex-1">{ENDONYMS[language]}</span>
            {i18n.language === language && <Check className="ml-auto h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
